import { TFunction } from 'i18next';
import React from 'react';

import { ModalConfirmation } from '../../../components/ModalConfirmation';

interface InactiveAgentConfirmationModalProps {
  customTitle?: string;
  isEdit: boolean;
  isOpen: boolean;
  isMultiQueueSchedule: boolean;
  onSubmit: () => void;
  onClose: () => void;
  scheduleName: string;
  t: TFunction;
}

export type InactiveAgentModalState =
  | {
      open: true;
      customSubmitHandler?: () => void;
      customTitle?: string;
      onSubmitSuccess: () => void;
      onSubmitError: () => void;
    }
  | {
      open: false;
    };

export const InactiveAgentConfirmationModal: React.FC<InactiveAgentConfirmationModalProps> = ({
  customTitle,
  isOpen,
  isEdit,
  isMultiQueueSchedule,
  scheduleName,
  onSubmit,
  onClose,
  t,
}) =>
  isOpen ? (
    <ModalConfirmation
      headerText={customTitle || t(`schedule.${isEdit ? 'update' : 'save'}`)}
      bodyText={t('schedule.modal.forcePushBody', {
        count: isMultiQueueSchedule ? 2 : 1,
        scheduleName: scheduleName || '',
      })}
      submitText={t('layout.action.proceed')}
      closeText={t('layout.action.cancel')}
      onSubmit={onSubmit}
      show
      onClose={onClose}
    />
  ) : null;
